import { EventEventRead } from '@/api/generated';
import { VARIANT_COLOR_ENUM } from '@/types/utils';
import { CMSEventType } from 'utils/cms/types';
import { ColorToken } from 'utils/colors';

type EventFormat = 'DRAFT' | 'STANDARD' | 'SEALED' | 'OTHER' | string;

export const getEventFormatIntlKey = (format?: EventFormat) => {
  switch (format) {
    case 'DRAFT':
      return 'event.eventFormat.DRAFT';
    case 'STANDARD':
      return 'event.eventFormat.STANDARD';
    case 'SEALED':
      return 'event.eventFormat.SEALED';
    case 'OTHER':
      return 'event.eventFormat.OTHER';
    default:
      return format || '';
  }
};

export const getEventStatusIntlKey = (status?: EventEventRead['status']) => {
  switch (status) {
    case 'DRAFT':
      return 'event.status.draft';
    case 'PUBLISHED':
      return 'event.status.published';
    case 'CANCELED':
      return 'event.status.canceled';
    case 'COMPLETE':
      return 'event.status.complete';
    case 'FINISHED':
      return 'event.status.finished';
    default:
      return status || '';
  }
};

export const getEventTypeIntlKey = (type: string) => `event.eventType.${type}`;

export const getEventGameFormatIntlKey = (type: string) => `event.gameFormat.${type}`;

export const EVENT_TYPE_COLOR_TO_VARIANT: Partial<Record<ColorToken, VARIANT_COLOR_ENUM>> = {
  nublu: VARIANT_COLOR_ENUM.NUBLU,
  neutral: VARIANT_COLOR_ENUM.NEUTRAL,
};

export const getCMSEventType = (eventTypes?: { [s: string]: CMSEventType } | null, eventTypeIri?: string) =>
  eventTypeIri ? eventTypes?.[eventTypeIri] : undefined;
